<div class="section-bar-container">
  <div class="descriptor">{{ displayString }}</div>
  <div class="section-bar">
    @for (section of sectionEntries; track section) {
      <div
        (click)="jumpToSection(section.vtcIn)"
        class="section"
        [style.left.%]="section.relativePosLeft"
        [style.width.%]="section.relativeWidth"
      ></div>
    }
  </div>
</div>
